import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
import { Link } from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Venue = () => {
  const showFlag = true;
  const conferenceRoomImage = "e8d4cceb5831e3ac364b73ba625073fd.jpg";

  return (
    <React.Fragment>
      <SEO title="Venue | ICSI 2026" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Venue"
        content="For Participants"
        contentTwo="Venue"
        linkage="/"

      />

      <EmptyTwo>
        {showFlag ? (
        <div className="entry-content accommodation-page venue-page">
          <section className="accommodation-section">
            <h3>ICSI 2026 will be hosted at Vision Hotel, Beijing, China.</h3>
            <p>
              <strong>唯实国际文化交流中心 欢迎您的光临!</strong>
              <br />
              <strong>WELCOME TO VISION HOTEL</strong>
            </p>
            <p>
              ICSI&apos;2026 will take place at{" "}
              <strong>Vision International Cultural Exchange Center (唯实国际文化交流中心)</strong>,
              also known as <strong>Vision Hotel (唯实酒店)</strong>. Located in Beijing&apos;s
              Haidian District, the venue offers modern meeting facilities, on-site accommodation,
              dining, and event spaces, providing delegates with a convenient and comfortable
              conference experience.
            </p>
            <p>
              <strong>Address:</strong> No. 39, Xueyuan Road, Haidian District, Beijing 100191, China
              <br />
              <strong>Chinese Address:</strong> 北京市海淀区学院路39号
              <br />
              <strong>Telephone:</strong> +86-10-62308899
              <br />
              <strong>Fax:</strong> +86-10-62308818
            </p>
          </section>

          <section className="accommodation-section">
            <h3>Host Venue: Vision Hotel</h3>
            <p>
              The conference registration, opening ceremony, plenary talks, parallel sessions,
              welcome reception, and banquet will be held at Vision Hotel. The venue features
              multifunctional meeting rooms, banquet halls, restaurants, and comprehensive conference
              support facilities.
            </p>
            <img
              className="accommodation-image"
              src={`${process.env.PUBLIC_URL}/images/accommodation/${conferenceRoomImage}`}
              alt="Conference room at Vision Hotel"
            />
            <p>
              Vision Hotel is conveniently located near Beijing&apos;s major universities and
              high-tech districts, with easy access to Metro Lines 10 and 13. For transportation
              details, please visit the{" "}
              <Link to={process.env.PUBLIC_URL + "/transportation"}>Transportation</Link> page.
            </p>
            <p>
              For recommended hotels and lodging information, please visit the{" "}
              <Link to={process.env.PUBLIC_URL + "/accommodation"}>Accommodation</Link> page.
            </p>
            <p>
              <a
                className="simple-link"
                href="https://www.beijingvision.cn/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Official website: www.beijingvision.cn
              </a>
            </p>
          </section>
        </div>
        ) : (
          <div className="entry-content title-center">
            <h2>
              Conference venue information is being updated. Please visit again soon.
            </h2>
          </div>
        )}
       

        {/* <div className="entry-content">
          <h3>Host Venue</h3>
          <p>
            The local organizing committee is finalizing the on-site venue in Chengdu&apos;s Tianfu New Area, an
            emerging district that hosts leading universities, research institutes, and high-tech companies.
            Final details, including the exact address, room allocation, and floor plans, will be released
            shortly after the venue agreement is completed.
          </p>
          <p>
            The conference site will feature modern lecture halls, breakout rooms, and networking spaces with
            full audiovisual support. It will be conveniently connected to the Chengdu Metro network and within
            easy reach of Chengdu Tianfu International Airport and Chengdu East Railway Station, enabling smooth
            travel for both domestic and international attendees.
          </p>





          The website of Kanagawa University: <a href="https://www.kanagawa-u.ac.jp">https://www.kanagawa-u.ac.jp</a>

          <br></br>
          <br></br>
          <img src="./images/venue/kanagawa.jpg" width={600}></img>


        </div> */}


        {/* <div className="entry-content">
          <div className="space-50"></div>
          <h3>Venue: Minato Mirai Campus of Kanagawa University</h3>
          The ICSI 2026 conference will be held at the <strong>Minato Mirai Campus</strong> of Kanagawa University, located in the heart of Yokohama&apos;s futuristic and vibrant <em>Minato Mirai 21</em> district. This area is well-known for its modern urban design, cultural attractions, and convenient transportation. The campus is equipped with state-of-the-art facilities and offers a scenic view of Yokohama Bay, providing an inspiring environment for academic exchange and collaboration.

          <br /><br />
          <strong>Address:</strong>
          4-5-3 Minatomirai, Nishi-ku, Yokohama, Kanagawa 220-8739, Japan

          <br /><br />
          <strong>Access:</strong><br />
          - 5 minutes&apos; walk from <em>Minatomirai Station</em> (Minatomirai Line)<br />
          - 10 minutes&apos; walk from <em>Sakuragicho Station</em> (JR Keihin-Tohoku/Negishi Line or Yokohama Municipal Subway)

          <br /><br />
          <strong>Metro Map:</strong>
          <br /><br />
          <img src="./images/transportation/metro.jpg" width={800}></img>

          <br /><br />
          <strong>Map:</strong>
          <div style={{ width: "100%", height: "400px", marginTop: "15px" }}>
            <iframe
              title="Minato Mirai Campus Map"
              width="100%"
              height="100%"
              frameBorder="0"
              style={{ border: 0 }}
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.097020991968!2d139.62914831525855!3d35.45762238024507!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60185c1a1d464ebf%3A0x6ef6311bacc35530!2sKanagawa%20University%20Minato%20Mirai%20Campus!5e0!3m2!1sen!2sjp!4v1653648603984!5m2!1sen!2sjp"
              allowFullScreen=""
              aria-hidden="false"
              tabIndex="0"
            ></iframe>

          </div>


          <p>The conference will be held on the <strong>4th floor</strong> of the venue, which features <strong>four classrooms</strong> equipped with state-of-the-art facilities to ensure a seamless and productive experience for all attendees.</p>

          <h3>Classroom Details:</h3>
          <ul className="classroom-list">
            <li><strong>4010 - Yoneda Yoshimori Memorial Hall</strong><br />
              This is the largest and most prominent lecture hall, named in honor of Professor Yoneda Yoshimori, a pioneer in the field of swarm intelligence. It will host keynote speeches, plenary sessions, and major presentations.</li>
            <li><strong>4007, 4008, 4009 - Standard Classrooms</strong><br />
              These three classrooms are ideal for parallel sessions, workshops, and smaller group discussions. Each room is equipped with modern audiovisual technology to support interactive and engaging presentations.</li>
          </ul>

          <h3>Venue Map:</h3>
          <p>For your convenience, please refer to the venue map below to locate the classrooms and other facilities on the 4th floor.</p>
          <img src="./images/venue/venue_map.jpg" alt="Venue Map" width={600}></img>




        </div> */}

        {/* <div className="entry-content">
          <h3>About the venue hotel</h3>

          <br></br>

            <h4>

          Qinghai Hotel
            </h4>
              <br></br>
          As one of the most popular luxury hotels in Xining, Qinghai Hotel is located in a prime location in the city and offers you the best quality service. Enjoy more discounts by booking online!
              <br></br>
              <br></br>

          Qinghai Hotel is situated in the center of Xining, with convenient transportation access. The main building stands 78 meters high, with a total construction area of 42,600 square meters, making it one of the most modern high-rise buildings in Qinghai Province. The hotel integrates dining, accommodation, transportation, tourism, shopping, and entertainment, making it an ideal place for tourism, conferences, and business activities in the Xining area. Qinghai Hotel offers various suites and standard rooms, equipped with central air conditioning, sound systems, satellite TV, and direct international and domestic dialing. The rooms are spacious and comfortable, and no matter which type of room you choose, you will enjoy the unique warmth of the hotel.
              <br></br>
              <br></br>

          The hotel has 12 restaurants of different styles, accommodating up to 1,500 people simultaneously. It offers a variety of cuisines, including Chinese and Western flavors and specialties from the north and south of China. It is an ideal venue for hosting various Chinese and Western banquets and cocktail parties. Here, you will feel invigorated and relaxed, and the personalized service will allow you to fully enjoy the ease and pleasure of business travel.
          <br></br>
          <br></br>
          For more information about the hotel, please visit the website: <a className="simple-link" href="http://qinghai.hotelxining.cn//">http://qinghai.hotelxining.cn/</a>

          <br></br>
          <br></br>
          <br></br>

          <table>
            <tr>
          <td width='50%'>
          <img
              src="./images/venue/hotel1.jpg"
              alt="hotel1"
              width="100%"
            />

          </td>
          <td width='50%'>
          <img
              src="./images/venue/hotel2.jpg"
              alt="hotel2"
              width="90%"
            />
          </td>
          </tr>
            <tr>
          <td width='50%'>
          <img
              src="./images/venue/hotel3.png"
              alt="hotel3"
              width="100%"
            />

          </td>
          <td width='50%'>
          <img
              src="./images/venue/hotel4.jpg"
              alt="hotel4"
              width="85%"
            />
          </td>
          </tr>
          </table>



          <h4>Location</h4>
          <br></br>

            <h4>

          Qinghai Hotel
            </h4>
          <strong>
          No. 158 Huanghe Road, Chengxi District, Xining, Qinghai Province, China Postal Code: 810001 • +86 971 614 4888
          </strong>
          <br></br>
          <br></br>
          Please refer to the{" "}
          <a href="https://maps.app.goo.gl/L5X8S1Z95ESzbAYK6">Google</a> or{" "}
          <a href="https://j.map.baidu.com/0f/1CT">Baidu</a> map to find the
          exact location of the conference venue.
          <p>&nbsp;</p>
          <div className="row">
            <iframe
              src="https://map.baidu.com/poi/%E9%9D%92%E6%B5%B7%E5%AE%BE%E9%A6%86/@11329205.725,4361040.85,19z?uid=38e48037e6e1b050363a71eb&ugc_type=3&ugc_ver=1&device_ratio=2&compat=1&pcevaname=pc4.1&querytype=detailConInfo&da_src=shareurl"
              width={900}
              height={600}
              loading="lazy"
            ></iframe>
          </div>

          <br></br>
          <h3>Venue</h3>
          <br></br>
          <br></br>
          <h4>Virtual Meeting</h4>
          <br></br>
          <div>
            Considering the current inconvenience of international travel, ICSI&apos;2026 also provides an
            online participation channel. Authors can join our conference through designated online
            conference software.
            The ICSI Organizing Committee has chosen Tencent Conference as the software for the
            online conference. For countries and regions outside of China, VooV Meeting can be used for
            participation. The room numbers for the meetings will be released soon.
            <br></br>
            <br></br>
            <strong>

              Note: Presentations should be in English.
            </strong>
          </div>
          <div className="space-60"></div> */}

        {/* <h4>How to participate online</h4>
          <br></br>
          <div className="crucial2">
            The ICSI Organizing Committee decided to use Tencent Conference as the software for online conference.
            Countries and regions other than China can use VooV Meeting to participate. Room numbers for meetings are listed below.
            <br></br>

          </div>

          <br></br>
          <table>
            <thead>
              <tr>
                <th > Room Name</th>
                <th > Room Code </th>
                <th > Agenda </th>
                <th > Time</th>
              </tr>
              <tr>
                <td>ICSI Information Desk</td>
                <td> 191-851-624   </td>
                <td>Information Desk
                </td>
                <td>
                  13:00-18:00, July 14th
                </td>

              </tr>
              <tr>
                <td>Opening Ceremony</td>
                <td>556-120-041   </td>
                <td>  Opening Ceremony </td>
                <td  > 08:30-12:00, July 15th</td>
              </tr>
              <tr>
                <td> Online Room 1</td>
                <td> 	881-943-032  </td>
                <td>  Parallel Session 4  </td>
                <td rowSpan={2} > 13:20 - 17:20, July 15th
                  <br></br>09:00 - 12:00, July 16th
                </td>
              </tr>
              <tr>
                <td>  Online Room 2</td>
                <td>  347-3932-3134  </td>
                <td>  Parallel Session 5 </td>
              </tr>
            </thead>
          </table> */}

        {/* <h3>How to Submit video</h3>
          <br></br>
          <div >
            The ICSI&apos;2026 conference supports the submission of speech videos to participate in the conference. If your speech time conflicts with your schedule, you can submit a 15-minute video, which will be played by the conference team.
            <br></br>
            <br></br>

            The video should be around 15 minutes long, using a PowerPoint presentation to introduce the content of your paper. The language should be English, and the resolution should be 720P or higher. We recommend using Tencent Meeting(VooV Meeting) or Zoom to record the video.
            <br></br>
            <br></br>
            The recorded video needs to be uploaded to the network disk and submitted to the conference team in the form of a link. It is recommended to use Alibaba Cloud or Baidu Cloud. And It is recommended to use onedrive in countries and regions other than China. The video needs to be submitted to the conference team two days in advance. 
            You can submit the video by sending the video link via email to the conference committee at icsi2026@iasei.org.
            <br></br>
            <br></br>
            <strong>
              Please note: Authors submitting videos are encouraged to participate in the opening ceremony and award ceremony of the conference.
            </strong>
          </div>

        </div>
        <div className="entry-content">
          <p>&nbsp;</p>
          <p>&nbsp;</p> */}

        {/* <h3>About the university</h3>
          Harbin Institute of Technology (Shenzhen), also known as HIT Shenzhen, is a Chinese university located in the city of Shenzhen. It is a satellite campus of the renowned Harbin Institute of Technology in Harbin, China. HIT Shenzhen was established in 2002, and it has quickly become a leading university in the fields of engineering, science, and technology.
          <br></br>
          <br></br>

          HIT Shenzhen offers undergraduate and graduate programs in a wide range of fields, including electrical engineering, mechanical engineering, computer science, materials science, and civil engineering. The university has a strong focus on research, and it has established a number of research centers and institutes in areas such as robotics, artificial intelligence, and advanced materials.
          <br></br>
          <br></br>
          As a modern and innovative university, HIT Shenzhen is committed to promoting international cooperation and exchange. The university has established partnerships with over 100 universities and research institutions around the world. It also has a large international student population, with students from more than 50 countries and regions.
          <p>&nbsp;</p>
          <p>&nbsp;</p> */}
        {/* </div> */}
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Venue;
